import { wsClient, WsRecvType, IWsHandler } from '../client'

type QuickSupportStatusData = {
    connected: boolean
    message: string
}

type QuickSupportDataData = {
    base64: string
}

type StatusCallback = (data: QuickSupportStatusData) => void
type DataCallback = (data: QuickSupportDataData) => void

const statusListeners: Array<{ id: number; callback: StatusCallback }> = []
const dataListeners: Array<{ id: number; callback: DataCallback }> = []
let inc = 0

export function QuickSupportHandler() {
    wsClient.submitHandler(WsRecvType.QuickSupportStatus, (({ data }) => {
        if (!data) return
        statusListeners.forEach(l => l.callback(data as QuickSupportStatusData))
    }) as IWsHandler<QuickSupportStatusData>)

    wsClient.submitHandler(WsRecvType.QuickSupportData, (({ data }) => {
        if (!data) return
        dataListeners.forEach(l => l.callback(data as QuickSupportDataData))
    }) as IWsHandler<QuickSupportDataData>)
}

export function onQuickSupportStatus(callback: StatusCallback): number {
    const id = ++inc
    statusListeners.push({ id, callback })
    return id
}

export function clearQuickSupportStatus(id: number) {
    const idx = statusListeners.findIndex(l => l.id === id)
    if (idx >= 0) statusListeners.splice(idx, 1)
}

export function onQuickSupportData(callback: DataCallback): number {
    const id = ++inc
    dataListeners.push({ id, callback })
    return id
}

export function clearQuickSupportData(id: number) {
    const idx = dataListeners.findIndex(l => l.id === id)
    if (idx >= 0) dataListeners.splice(idx, 1)
}
